import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { shouldSkipLoader } from '@core/utils/loader.utils';
import { LoaderService } from '@sharedModule/services/loader/loader.service';
import { finalize } from 'rxjs';

export const loaderInterceptor: HttpInterceptorFn = (req, next) => {
  const loaderService = inject(LoaderService);

  // Skip loader for specific URLs or request types
  if (shouldSkipLoader(req)) {
    return next(req);
  }

  // Show loader
  loaderService.show();

  return next(req).pipe(
    finalize(() => {
      // Hide loader when request completes (success or error)
      loaderService.hide();
    })
  );
};
